import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { ManagePlanTrialModalComponent } from "./ManagePlanTrialModalComponent";

const ManagePlanTrialModal = ModalManager.create(() => (
  <ManagePlanTrialModalComponent />
));

export const useManagePlanTrialModal = () => useModal(ManagePlanTrialModal, {});
